import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { OutputDataUrl } from './OutputDataUrl';
import { CalculateTimeSeriesType } from '../schema/types';
import { CalculateTimeSeriesMutationSchema } from '../schema/OutputDataSchema';

const postTimeSeriesCalculateOutputData = async (
  request: CalculateTimeSeriesType,
  headers?: HttpHeaders,
) =>
  apiClient
    .post<void>(
      OutputDataUrl.OUTPUT_DATA_TIMESERIES_CALCULATIONS,
      CalculateTimeSeriesMutationSchema.parse(request),
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useTimeSeriesCalculateOutputData = createApiMutationHook(
  ['calculateTimeSeriesOutputData'],
  getMutationFn(postTimeSeriesCalculateOutputData),
);
